<template lang="pug">
  div(:class="'image-grid '+'container-'+this._uid+' '+this.classes")
    img(v-for="(n, i) in this.images" :src="n.fields.file.url" :alt="n.fields.title" v-in-viewport.once="")
</template>

<script>
import Vue from 'vue'
import sectionBase from '@/components/sections/sectionBase.js'

// component instance
var imageGrid = Vue.component('image-grid', {
  name: 'imageGrid',
  mixins: [sectionBase],
  props: [],
  data: function () {
    return {
    }
  },
  watch: {
  },
  methods: {
  },
  computed: {
    images () {
      return this.payload.fields.content[0].fields.images
    }
  },
  created () {
  },
  mounted () {
  },
  beforeCreate () {
  },
  beforeUpdate () {
  },
  beforeDestroy () {
  }
})

// export component
export default imageGrid
</script>

<style scoped lang="scss">
.image-grid{
  display: flex;
  flex: 1;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-evenly;
  padding: 2rem 0;

  img{
    transition: opacity .2s .1s ease-in-out;
    &.below-viewport{
      opacity: 0;
    }
    &.in-viewport{
      opacity: 1;
    }
  }

  &.mobile-small{
    img{
      @include breakpoint(small){
        max-height: 15vw;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sections/imageGrid.vue